import { defineMessages, FormattedDate, FormattedMessage } from 'react-intl';

import styles from './RepaymentSummaryItem.module.css';
import { IwDynamicFormattedMessage } from '../../../iwDynamicFormattedMessage/IwDynamicFormattedMessage';
import { MoneyWithDecimals } from '../moneyWithDecimals';

const messages = defineMessages({
    monthly: {
        id: '_.repayment_summary_item.date.monthly',
        // eslint-disable-next-line formatjs/blocklist-elements
        defaultMessage: `{monthDay, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} of each month`
    },
    weekly: {
        id: '_.repayment_summary_item.date.weekly',
        defaultMessage: 'every {weekDay}'
    },
    Monday: {
        id: '_.repayment_summary_item.date.monday',
        defaultMessage: 'Monday'
    },
    Tuesday: {
        id: '_.repayment_summary_item.date.tuesday',
        defaultMessage: 'Tuesday'
    },
    Wednesday: {
        id: '_.repayment_summary_item.date.wednesday',
        defaultMessage: 'Wednesday'
    },
    Thursday: {
        id: '_.repayment_summary_item.date.thursday',
        defaultMessage: 'Thursday'
    },
    Friday: {
        id: '_.repayment_summary_item.date.friday',
        defaultMessage: 'Friday'
    },
    Saturday: {
        id: '_.repayment_summary_item.date.saturday',
        defaultMessage: 'Saturday'
    },
    Sunday: {
        id: '_.repayment_summary_item.date.sunday',
        defaultMessage: 'Sunday'
    }
});

const RepaymentSummaryItem = ({
    amount,
    description,
    interval,
    value
}: {
    amount: number | null;
    description: React.ReactNode;
    value: string | number | null;
    interval?: string;
}) => {
    return (
        <div className={styles.RepaymentSummaryItem}>
            <div className={styles.nextRepaymentContainer}>
                <div className={styles.nextRepaymentLabel}>
                    <FormattedMessage
                        id="_.next_repayment_summary.label"
                        defaultMessage="Next repayment"
                    />
                </div>

                {amount !== null && (
                    <div className={styles.nextRepaymentDate}>
                        <RepayDate interval={interval} value={value} />
                    </div>
                )}
            </div>

            <div className={styles.amountLine}>
                <MoneyWithDecimals
                    integerWithSymbolClassName={styles.RepayMoneyInteger}
                    decimalWithSeparatorClassName={styles.RepayMoneyDecimals}
                    className={styles.RepayMoney}
                    value={amount!}
                />
            </div>

            {description && (
                <div className={styles.RepayDescription}>{description}</div>
            )}
        </div>
    );
};

// eslint-disable-next-line
export default RepaymentSummaryItem;

const RepayDate = ({
    value,
    interval
}: {
    value: string | number | null;
    interval?: string;
}) => {
    if (!value) {
        return null;
    }

    switch (interval) {
        case 'Weekly':
            const dayOfWeek = [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday'
            ][value as number];

            const weekDay = (
                <IwDynamicFormattedMessage
                    messages={messages}
                    messageKey={dayOfWeek}
                />
            );
            return (
                <div className={styles.RepayDate}>
                    <FormattedMessage
                        id="_.repayment_summary_item.date.weekly"
                        defaultMessage="every {weekDay}"
                        values={{ weekDay }}
                    />
                </div>
            );

        case 'Monthly':
            return (
                <div className={styles.RepayDate}>
                    <FormattedMessage
                        id="_.repayment_summary_item.date.monthly"
                        // eslint-disable-next-line formatjs/blocklist-elements
                        defaultMessage="{monthDay, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} of each month"
                        values={{ monthDay: value }}
                    />
                </div>
            );

        default:
            return (
                <FormattedDate
                    day="numeric"
                    month="long"
                    year="numeric"
                    value={new Date(value)}
                />
            );
    }
};
